/* eslint-disable space-before-blocks */
/* eslint-disable no-return-assign */
/* eslint-disable comma-dangle */
/* eslint-disable spaced-comment */
/* eslint-disable padded-blocks */
/* eslint-disable no-dupe-keys */
/* eslint-disable quotes */
/* eslint-disable space-before-function-paren */
/* eslint-disable no-useless-return */
/* eslint-disable semi */
/* eslint-disable no-tabs */
import CoverageAreaList from './coverageAreaList.vue'
import CoverageAreaLocationList from './coverageAreaLocationList.vue'
import coverageAreaListDetail from './coverageAreaListDetail.vue'
import i18n from "../../../i18n/index"
import locationService from '../../../services/location/LocationService.js'
import createCoverageArea from '../../../services/branch/coverageArea/coverageArea.js'
import branchService from "../../../services/branch/BranchService.js"

export default {
	data: () => ({
		rules: { required: value => !!value || i18n.t('field-required') },
		showDetail: false,
		branchCitiesDetail: [],
		colorValidate: null,
		dataCoverageArea: null,
		validateCitie: null,
		hideList: false,
		location: {
			state: '',
			city: '',
			branche_id: null
		},
		branch: {
			editFunction: false,
			id: '',
			name: '',
			branchId: '',
			providerId: '',
			type: '',
			branchCities: [],
			listCities: [],
			inactiveCities: [],
			newBranches: [],
			justification: '',
			state: '',
			editCities: [],
			editCitiesNoCoverage: [],
		},
		coverage: false,
		branches: [],
		states: [],
		cities: [],
		dialog: false,
		headers: [
			{
				text: 'Fecha novedad',
				align: 'left',
				sortable: false,
				value: 'noveltieDate'
			},
			{
				text: 'Departamento - Municipio',
				align: 'left',
				sortable: false,
			},
			{ text: 'Campo', value: 'field', sortable: false },
			{ text: 'Valor anterior', value: 'previousValue', sortable: false },
			{ text: 'Valor actual', value: 'currentValue', sortable: false },
			{ text: 'Usuario', value: 'user', sortable: false },
			{ text: 'Justificación', value: 'justification', sortable: false }
		],
		items: [],
		previousValue: null,
		currentValue: null,
		field: null,
		stateName: null,
		municipalityName: null,
		disabledUpdate: true,
		inactiveCities: {},
		editCities: [],
		editCitiesNoCoverage: [],
	}),
	components: { CoverageAreaList, CoverageAreaLocationList, coverageAreaListDetail },
	watch: {
		// 'branch.inactiveCities': {
		// 	handler(value){
		// 		if (value !== []){
		// 			return	this.disabledUpdate = false
		// 		}
		// 	}
		// },
		'branch.newBranches': {
			handler(value){
				if (value !== []){
					return	this.disabledUpdate = false
				}
			}
		},
		'editCitiesNoCoverage': {
			handler(value){
				if (value === [] && this.branch.justification !== ''){
					return	this.disabledUpdate = false
				}
			}
		},
		// 'currentValue': {
		// 	handler(value){
		// 			if (value !== null){
		// 				return	this.disabledUpdate = false
		// 			}
		// 		}
		// 	},
			'branch.justification': {
				handler(value){
						if (value === '' || this.editCitiesNoCoverage === []){
							return	this.disabledUpdate = true
						} else {
							return	this.disabledUpdate = false
						}
					}
				}
	},
	methods: {
		showFunction() {
			this.hideList = false
			this.showDetail = false
		},
		async onRowClick(item) {
			this.disabledUpdate = true
			this.previousValue = null
			this.currentValue = null
			this.field = null
			this.branch.editFunction = true
			this.showDetail = true
			this.hideList = true
			await this.getBranches()
			await this.getStates()
			this.branch.branchId = item.id
			this.branches = this.branches.filter(b => b.id == this.branch.branchId)
			this.branch.branchCities = item.branchCities.map(obj => {
				return {
					code: obj.idCity.code,
					noCoverage: obj.noCoverage,
					responseDays: obj.responseDays,
					id: obj.idCity.id,
					name: obj.idCity.name,
					idState: {
						code: obj.idCity.idState.code,
						id: obj.idCity.idState.id,
						name: obj.idCity.idState.name
					},
				}
			})
			this.$refs.areaDetail.addData(item)
			await createCoverageArea.getNovelty(item.id).then(res => {
				if (res.data.code){
					this.items = []
				} else {
					this.items = res.data
				}
			}).catch(error => {
				console.log('error',error)
			})
		},
		closeCreate() {
			this.hideList = false
			this.branch.editFunction = false
			this.branch.branchId = null
			this.branch.branchCities = []
			this.branch.listCities = []
			this.branch.inactiveCities = []
			this.branch.newBranches = []
			this.branch.justification = ''
			this.editCities = []
			this.editCitiesNoCoverage = []
			this.branch.editCities = []
			this.branch.editCitiesNoCoverage = []
			this.showFunction()
		},
		async create() {
			if (this.branch.editFunction){
				let user = JSON.parse(localStorage.getItem('user'))
				const creationDate = new Date()

				this.branch.previousValue = this.previousValue
				this.branch.currentValue = this.currentValue
				this.branch.state = this.stateName
				this.branch.municipality = this.municipalityName
				this.branch.field = this.field
				this.branch.creationDate = creationDate
				this.branch.userName = user.name
			}
			if ((this.branch.field === null && this.branch.editFunction) && this.branch.newBranches.length < 1 && this.branch.inactiveCities < 1){
				this.$notify({
					group: "app",
					type: "error",
					text: "No puedes guardar una justificacion sin algun cambio"
				})
			} else {

				if ((this.branch.justification === '' && this.branch.editFunction && this.branch.newBranches.length < 1)){
					this.$notify({
						group: 'app',
						type: 'error',
						text: i18n.t('justification-alert')
					})
				} else {
					if (this.branch.branchCities.length === 0) {
						this.$notify({
							group: "app",
							type: "error",
							text: i18n.t("branches.error-no-city")
						})
						return;
					}
				}
				if (this.editCitiesNoCoverage !== [] || this.editCities !== []) {
					createCoverageArea.createCoverageArea(this.branch).then(res => {
						this.$refs.coverageAreaList.get()
						this.$notify({
							group: "app",
							type: "success",
							text: "Campo actualizado con éxito"
						})
						// this.branch.justification = ''
						// this.disabledUpdate = true
						// this.branch.inactiveCities = []
					}).catch(error => {
						if (error && error.code) {
							const errorCode = error.code
							if (errorCode === 'COVERAGE_OVERLAY') {
								this.$notify({
									group: 'app',
									type: 'error',
									text: i18n.t('branches.error-coverage-overlay')
								})
							}
							if (errorCode === 'EXISTING_BRANCH_CITY') {
								this.$notify({
									group: 'app',
									type: 'error',
									text: i18n.t('EXISTING_BRANCH_CITY')
								})
							}
							if (errorCode === 'HAS_SHIPPING_FEE') {
								this.$notify({
									group: 'app',
									type: 'error',
									text: i18n.t('HAS_SHIPPING_FEE')
								})
							}
						}
					})
					if (this.branch.justification !== ''){
						let requests = []
						const inactiveCities = this.branch.inactiveCities
						inactiveCities.forEach(element => {
							this.branch.field = 'Eliminar'
							this.branch.previousValue = 'Activo'
							this.branch.currentValue = 'Inactivo'
							this.branch.municipality = element.name
							this.branch.state = element.idState.name
							requests.push(Object.assign({}, this.branch))
						});
						await Promise.all(requests.map(rq => createCoverageArea.createNovelty(rq)))
						.then(res => {
							this.branch.inactiveCities = []
						}).catch(error => {
							console.log('error',error)
						})
					}
					if (this.editCities !== []){
						let requests2 = []
						this.editCities.map(item => {
							this.branch.municipality = item.name
							this.branch.previousValue = item.previousValue
							this.branch.currentValue = item.responseDays
							this.branch.state = item.idState.name
							this.branch.field = 'Dias de respuesta'
							requests2.push(Object.assign({}, this.branch))
						})
						await Promise.all(requests2.map(rq => createCoverageArea.createNovelty(rq)))
						.then(res => {
							this.editCities = []
							this.branch.editCities = []
						}).catch(error => {
							console.log('error',error)
						})
					}
					if (this.editCitiesNoCoverage !== []){
						let requests3 = []
						this.editCitiesNoCoverage.map(item => {
							this.branch.municipality = item.name
							this.branch.previousValue = item.noCoverage === true ? 'Inactivo' : 'Activo'
							this.branch.currentValue = item.noCoverage === true ? 'Activo' : 'Inactivo'
							this.branch.state = item.idState.name
							this.branch.field = 'No cobertura'
							requests3.push(Object.assign({}, this.branch))
						})
						await Promise.all(requests3.map(rq => createCoverageArea.createNovelty(rq)))
						.then(res => {
							this.editCitiesNoCoverage = []
							this.branch.editCitiesNoCoverage = []

						}).catch(error => {
							console.log('error',error)
						})
					}
				}
				this.branch.inactiveCities = []
				this.branch.newBranches = []
				this.branch.justification = ''
				this.editCitiesNoCoverage = []
				this.field = null
				return
				}
		},
		keyPresData(item){
			if (this.branch.justification !== ''){
				let object = Object.assign(item, {
					justification: this.branch.justification
					});
				this.branchCities.push(object)
			}
		},
		changesInTable(noCoverage, stateName, municipalityName){
			this.stateName = stateName
			this.municipalityName = municipalityName
			this.previousValue = noCoverage === true ? 'Inactivo' : 'Activo'
			this.currentValue = noCoverage === true ? 'Activo' : 'Inactivo'
			this.field = 'No cobertura'
		},
		changesInTableResponseDays(responseDays){
			this.previousValue = responseDays[0]
			this.currentValue = responseDays[1]
			this.stateName = responseDays[2]
			this.municipalityName = responseDays[3]
			this.field = 'Dias de respuesta'
		},
		addCity(city) {
			if (!this.$refs.branchForm.validate()) {
				this.$notify({
					group: "app",
					type: "error",
					text: i18n.t("app.error-required-fields")
				})
				return;
			}
			let cityToAdd = city

			if (!city) {
				if (this.location.city === '') return
				cityToAdd = this.cities.find(c => c.id === this.location.city)
			}

			if (this.branch.branchCities.some(c => c.id === cityToAdd.id)) {
				this.$notify({
					group: "app",
					type: "error",
					text: i18n.t("branches.error-city-already-in-branch")
				})
				return;
			}
			createCoverageArea.validateCitie(this.branch.branchId, this.branch.editFunction,
				this.location.city, this.location.state).then(res => {
					this.validateCitie = res.data
					if (this.validateCitie === 'La sede seleccionada ya existe') {
						this.colorValidate = 'error'
					} else if (this.validateCitie === 'El municipio seleccionado está asociado a otra sede del prestador') {
						this.colorValidate = 'error'
					} if (this.validateCitie === 'Guardado con éxito') {
						this.colorValidate = 'success'
						this.branch.newBranches.push(cityToAdd)
						this.branch.listCities.push(cityToAdd)
						this.branch.branchCities.push(cityToAdd)
						this.location.state = ''
						this.location.city = ''
						this.cities = []
						this.$emit('pushData', this.branchCities)
					}
					if (this.validateCitie === '') {
						return
					}
					this.$notify({
						group: "app",
						type: this.colorValidate,
						text: this.validateCitie
					}); console.log(res)
				})

		},
		async getBranches() {
			let response = await branchService.allBranches()
			this.branches = response.data[0]
		},
		// async showCreate() {
		// 	await this.getBranches()
		// 	await this.getStates()
		// 	this.hideList = true
		// },
		// async getStates() {
		// 	await locationService.getStatesByCountry().then(response => {
		// 		this.states = response.data
		// 		this.location.state = ''
		// 		this.location.city = ''
		// 	})
		// },
		// getCities() {
		// 	locationService.getCitiesByState(this.location.state).then(response => {
		// 		this.cities = response.data
		// 		this.location.city = ''
		// 	})
		// },
		deletebranchCitiesDetail(itm) {
			let cityToInactive = itm
			if (!itm) {
				if (this.location.city === '') return
				cityToInactive = this.cities.find(c => c.id === this.location.city)
			}

			this.branch.inactiveCities.push(cityToInactive)
		},
		async showCreate() {
			await this.getBranches()
			await this.getStates()
			this.hideList = true
			this.branch.editFunction = false
		},
		async getStates() {
			await locationService.getStatesByCountry().then(response => {
				this.states = response.data
				this.location.state = ''
				this.location.city = ''
			})
		},
		getCities() {
			locationService.getCitiesByState(this.location.state).then(response => {
				this.cities = response.data
				this.location.city = ''
			})
		},
		openNovelties() {
			this.dialog = true
			createCoverageArea.getNovelty(this.branch.branchId).then(res => {
				if (res.data.code){
					this.items = []
				} else {
					this.items = res.data
				}
			}).catch(error => {
				console.log('error',error)
			})
		},
		editBranchDetail (city) {
			this.branch.editCities.push(city)
			const editCities = this.branch.editCities.filter((item,
				index) => this.branch.editCities.indexOf(item) === index);

			this.editCities = editCities
		},
		editNoCoverageDetail (city) {
			this.branch.editCitiesNoCoverage.push(city)
			const editCitiesNoCoverage = this.branch.editCitiesNoCoverage.filter((item,
				index) => this.branch.editCitiesNoCoverage.indexOf(item) === index);

			this.editCitiesNoCoverage = editCitiesNoCoverage
		}
	},
}
